import React, { Component } from 'react';
import { connect } from "react-redux";
import * as _ from 'lodash'
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/free-solid-svg-icons'
//image
import account_icon from '../../assets/images/Account-icon.svg';
import channelImageBg from '../../assets/images/channelImageBg.jpg';
import loading_white from '../../assets/gif/loading_white.gif';
//internal imports
import * as actions from "../../actions";
import { isEmpty, navigate, required, vuepayAlert, removeWordFromList, showModal, hideModal, openYotiIframe } from "../../util/utility";
import { getData, LOGIN } from "../../util/storage";
import YotiConfirmModal from "../../components/modal/YotiModal";
import {
    checkIfPrefinedTags,
    getCanvasImage,
    getChannelDescription,
    getChannelPicture,
    getTagsForAPI,
    isProfileCreated,
    tagsObject
} from "../../util/broadcaster/profile_util";
import ModelTemp from "../../components/modal/ModelTemp";
import PlaceHolderComponent from "../../components/PlaceHolderComponent";

import { getUserDetailsFromAPI, renderTextAreaField } from "../../util/account_management";
import ChannelPictureModal from "../../components/modal/ChannelPictureModal";

class CreateBroadcasterProfile extends Component {

    constructor() {
        super();

        this.state = {
            userDetails: null,
            tags: [],
            count: 0,
            image: null,
            previewImage: null,
            registerProfile: true, // if profile is registered first time then this value will set to false to perform YOTI process
            uploadType: "broadcaster_channel_image",//broadcaster_profile_pic,user_profile_pic
            yotiModalStatus: false,
        };

        //all the functions used in this component should be listed here for better documentation
        this.textAreaChange = this.textAreaChange.bind(this);
        this.uploadChannelImage = this.uploadChannelImage.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onClickSave = this.onClickSave.bind(this);
    }

    /**
     * @function is invoked immediately after a component is mounted. Initialization that requires DOM nodes should go here.
     * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
     */
    componentDidMount() {
        document.getElementsByClassName("modal-overlay")[0].style.display = "none";
        this.props.hideLeftBar(); //hide the leftbar

        //every time the create broadcast is loaded we check if the user api_token and token is available
        //it the api_token and token is available we do hit getUserDetails Webservice
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.getUserDetails(data.token, data.api_token);
                    this.props.getPreDefinedTags(data.token, data.api_token);
                }
            });
    };

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        //check if user profile is created if YES redirect user to
        if (isProfileCreated(nextProps, false)) {
            //move to broadcaster create profile if not any
            this.state.registerProfile && navigate(nextProps, "broadcaster_availability");
            // this.state.registerProfile && navigate(nextProps, "broadcaster_create_broadcast");
            if(!this.state.registerProfile) 
            {document.getElementsByClassName("modal-overlay")[0].style.display = "block";}
        } else {

            //check if we have user information if yes use only once to initialize
            if (nextProps.account_management.userDetails !== null && this.state.userDetails === null) {
                this.setState({
                    count: getChannelDescription(nextProps, 0),
                    userDetails: nextProps.account_management.userDetails
                })
            }

            if (nextProps.broadcasterProfile.hasOwnProperty("payload")
                && nextProps.broadcasterProfile.payload !== null) {

                if (nextProps.broadcasterProfile.payload.hasOwnProperty("data") &&
                    nextProps.broadcasterProfile.payload.data !== null &&
                    nextProps.broadcasterProfile.payload.data.length > 0) {

                    this.setState({
                        userDetails: nextProps.broadcasterProfile.payload.data[0]
                    })
                }

                if (nextProps.broadcasterProfile.payload.hasOwnProperty("status_code")) {
                    const message = nextProps.broadcasterProfile.payload.message;
                    nextProps.resetUploadChannelPicture();
                    if (nextProps.broadcasterProfile.payload.status_code === 200) {
                        vuepayAlert("success", message, () => {
                            getUserDetailsFromAPI(this.props)
                        })
                    } else {
                        vuepayAlert("error", message)
                    }
                    this.resetUploadImage()
                    if (isProfileCreated(nextProps, true)) {
                        //move to broadcaster create profile if not any
                        this.state.registerProfile && navigate(nextProps, "broadcaster_availability");
                        // this.state.registerProfile && navigate(nextProps, "broadcaster_create_broadcast");
                    }
                }
            }
        }

        if (nextProps.account_management.yotiDetails !== null && nextProps.account_management.userDetails.broadcaster[0].is_verified == 0) {
            openYotiIframe(nextProps.account_management.yotiDetails.url)
        }

    }

    handleOnBlur = (event) => {
        const newData = removeWordFromList(this.props.account_management.userDetails.broadcaster[0].id, this.props.profanity, event.target.value, true, false);
        event.target.value = newData;
    }

    /**
     * @function removes the image from the file
     */
    resetUploadImage = () => {
        this.setState({
            image: null
        })
    };

    /**
     * @function listener for text area change we use this to maintain the count of the characters the user has typed
     * @param e
     */
    textAreaChange(event, newValue, previousValue, name) {
        setTimeout(() => {
            const newData = removeWordFromList(this.props.account_management.userDetails.broadcaster[0].id, this.props.profanity, event.target.value, true, false);
            this.props.dispatch(this.props.change(name, newData));
            this.setState({
                count: newData.length,
            });
        }, 0);
    }

    /**
     * @function make webservice call to upload the channel image
     * @param blob
     */
    uploadChannelImage = (blob) => {

        const formData = new FormData();
        formData.append("channel_pic_square", blob);
        formData.append("channel_pic_rectangle", this.state.image);
        formData.append("device[platform]", this.props.device.platform);
        formData.append("device[name]", this.props.device.name);
        formData.append("device[version]", this.props.device.version);
        formData.append("device[ip]", this.props.device.ip);
        formData.append("device[id]", this.props.device.id);
        formData.append("device[app_version]", this.props.device.app_version);
        formData.append("device[device_token]", this.props.device.device_token);

        //dispatch an action to POST the channel picture/image to the Webservice
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.uploadChannelPicture(data.token, data.api_token, formData);
                }
            })
    }

    /**
     * @function listener for channel image change we use this to maintain updated file uploaded by the user
     * @param evt
     */
    onChange = (evt) => {
        this.setState({
            image: evt.target.files[0]
        })
    };

    /**
     * @function listener when user clicks on SAVE button, we process the image as below
     * 1. Take the image file and save the original file in this.state.image
     * 2. Convert the image file into canvas and crop it to a square image
     * 3. Convert the square image into blob
     * 4. Call uploadChannelImage WebService
     */
    onClickSave = (e) => {

        getCanvasImage(e, this.editor, (blob) => {
            this.setState({
                previewImage: blob
            }, () => {
                this.uploadChannelImage(blob);
            })
        })
    }

    //this is reference for the channel image
    setEditorRef = (editor) => this.editor = editor

    /**
     * @function click listener for predefined tags which is use to toggle the state of the tags
     * @param e
     */
    togglePrefinedTags = (e) => {
        e.preventDefault();

        const element = document.getElementById(e.target.id);
        const name = e.target.dataset.name;
        const id = e.target.dataset.id;

        if (!element.classList.contains("active")) {
            if (this.addElementIntoArray(tagsObject(id, "true", name))) {
                element.classList.toggle("active")
            }
        } else {
            //remove the element
            const find = tagsObject(id, "true", name);
            this.removeElementFromArray(find)
        }
    }

    /**
     * @function click listener for adding custom tags
     * @param e
     */
    addTag = (e) => {
        e.preventDefault();

        const value = document.getElementById("create-new-tag").value;
        /**
         * Business rule
         * minimum length 2
         */
        if (value.length > 2) {
            this.addElementIntoArray(tagsObject(null, "false", value));
        } else {
            vuepayAlert("error", "Tag length should be more than two.")
        }
    }

    /**
     * @function which mutates the state of tags by adding more content
     * @param object
     * @returns {boolean}
     */
    addElementIntoArray = (object) => {
        let tags = this.state.tags;

        if (tags.length === 5) {
            vuepayAlert("error", "Maximum of five tags are allowed")
            return false;
        } else {
            //add new object into array
            const tagObj = this.state.tags.find(o => o.name.toLowerCase() === object.name.toLowerCase());
            if (tagObj == null || tagObj == undefined) {
                tags.push(object);
                this.setState({
                    tags: tags
                }, () => {
                    document.getElementById("create-new-tag").value = "";
                })
                return true;
            }
            else {
                vuepayAlert("error", "Tag already exists")
                return false;
            }
        }
    }

    /**
     * @function which mutates the state of tags by removing content
     * @param find
     */
    removeElementFromArray = (find) => {
        /*
         * 1. This will return the *index of the first* element that matches:
         */
        const index = _.findIndex(this.state.tags, (o) => {
            return _.isMatch(o, find)
        });

        //add the element
        let tags = this.state.tags;

        //Remove 1 element from index 3
        tags.splice(index, 1);

        this.setState({
            tags: tags
        }, () => {
            const element = document.getElementById("predefined-" + find.id);
            if (element) {
                element.classList.remove("active")
            }
        })
    }

    /**
     * @function click listener for deleting tags from my tags
     * @param e
     */
    removeTag = (e) => {
        e.preventDefault();
        const id = e.target.dataset.id;
        const ispredefined = e.target.dataset.ispredefined;
        const name = e.target.dataset.name;
        const find = tagsObject(id, ispredefined, name);

        this.removeElementFromArray(find)
    }

    /**
     * @function click listener for create profile button which validates the form locally and then calls the webservice
     * @param e
     */
    createProfile = (e) => {
        e.preventDefault();
    
        if (getChannelPicture(this.state.userDetails, null) === null) {
            vuepayAlert("error", "Please upload channel picture")
        } else if (document.getElementsByName("channel_description")[0].value.length < 10) {
            vuepayAlert("error", "Channel description should be minimum of 10 characters long")
        } else if (this.state.tags.length === 0) {
            vuepayAlert("error", "Please select a minimum of one tag")
        } else {
            //dispatch an action to POST the channel picture/image to the Webservice
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        this.setState({
                            registerProfile: false
                        })
                        
                        const modal = document.getElementById("common-modal");
                        showModal(modal);
                        
                        this.props.createBroadcasterProfile(data.token, data.api_token, {
                            tags: getTagsForAPI(this.state.tags),
                            description: document.getElementsByName("channel_description")[0].value,
                            device: this.props.device
                        });
                    }
                })
        }
    }

    callYotiIntegration = () => {
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.setState({
                        yotiModalStatus: true,
                    });
                    this.props.yotiIntegration(data.token, data.api_token);
                }
            })
    }

    navCreateBroadcast = () => {
        // navigate(this.props, "broadcaster_create_broadcast");
        this.setState({
            yotiModalStatus: false,
        });
        navigate(this.props, "broadcaster_availability");
    }


    render() {

        const ready = checkIfPrefinedTags(this.props);

        return (
            <div>
                <ModelTemp>

                    <ChannelPictureModal
                        id={"channel-image-modal"}
                        type={this.state.uploadType}
                        setUserDetails={(userDetails) => {
                            this.setState({
                                userDetails
                            })
                        }} />

                    <main role="main" className="">
                        <div className="profile-container">
                            <h4>Broadcaster profile</h4>
                            <form>

                                <div className="profile-wrapper">

                                    <input ref='file'
                                        type='file'
                                        id="upload_photo"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={this.onChange} />

                                    <div className="top-card-channel-image relative">
                                        <div tabIndex="0" id="ember2683"
                                            className="channel-image--no-rounded-corners channel-image ember-view">
                                            <div className="channel-image__image-container">
                                                <img
                                                    className="channel-image__image relative full-width"
                                                    id="channel-image-target-image" alt="Background Image"
                                                    src={getChannelPicture(this.state.userDetails, channelImageBg, "channel_image_rectangle")} />
                                            </div>
                                        </div>

                                        <div className="channel-image-edit-button ember-view">
                                            <button data-control-name="edit-channel-image"
                                                className="channel-image-edit-button__edit-icon icon-button icon-button--circle icon-button--inverse icon-button--1 icon-button--primary ember-view"
                                                type="button"
                                                onClick={() => {
                                                    //"broadcaster_channel_image"//broadcaster_profile_pic,user_profile_pic
                                                    this.setState({
                                                        uploadType: "broadcaster_channel_image"
                                                    }, () => {
                                                        document.getElementById("channel-image-modal-file").click()
                                                    });
                                                }}>
                                                <FontAwesomeIcon icon={faPen} size="xs" />
                                                <span className="icon-button__text">Upload Background Photo</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="followers-img-wrapper">
                                        <div className="followers-img">
                                            <img
                                                src={getChannelPicture(this.state.userDetails, account_icon, "profile_pic")}
                                                alt="Accounts icon" /></div>
                                        <div className="icon-edit"
                                            onClick={() => {
                                                //"broadcaster_channel_image"//broadcaster_profile_pic,user_profile_pic
                                                this.setState({
                                                    uploadType: "broadcaster_profile_pic"
                                                }, () => {
                                                    document.getElementById("channel-image-modal-file").click()
                                                });
                                            }} />
                                    </div>


                                    <div className="form-group">
                                        <Field
                                            label="Channel description"
                                            name="channel_description"
                                            type="textarea"
                                            maxLength="500"
                                            count={this.state.count}
                                            validate={[required]}
                                            component={renderTextAreaField}
                                            onChange={this.textAreaChange}
                                        />
                                    </div>
                                    <p>Channel tags</p>
                                    <div className="vertical-container-100">
                                        <PlaceHolderComponent type={'text'} rows={5} ready={ready}>

                                            <ul className="tags">
                                                {
                                                    ready && _.map(this.props.predefinedTags.payload, (tag) => {
                                                        return <li key={tag.id} id={`predefined-${tag.id}`}
                                                            onClick={this.togglePrefinedTags}
                                                            data-id={tag.id}
                                                            data-name={tag.name}>{tag.name}</li>;
                                                    })
                                                }
                                            </ul>

                                        </PlaceHolderComponent>
                                    </div>
                                    <div className="form-group add-tags">
                                        <input className="form-control" type="text" onBlur={(event) => this.handleOnBlur(event)} onChange={(event) => this.handleOnBlur(event)} maxLength="20" placeholder="Create new tag"
                                            id="create-new-tag" />
                                        <button className="btn btn-outline-primary" onClick={this.addTag}>Add tag
                                    </button>
                                    </div>
                                    <p>Your tags</p>
                                    <div style={{ margin: '10px 0 10px 0' }}> You can select a minimum of one tag and maximum
                                    of five
                                </div>
                                    <div className="vertical-container-100">
                                        <ul className="tags">
                                            {
                                                _.map(this.state.tags, (tag, index) => {
                                                    return <li key={index}
                                                    >{tag.name}
                                                        <span className="close"
                                                            data-id={tag.id}
                                                            data-ispredefined={tag.ispredefined}
                                                            data-name={tag.name}
                                                            onClick={this.removeTag}>×</span>
                                                    </li>
                                                })
                                            }
                                        </ul>
                                    </div>
                                    <div className="mt-3 text-right">
                                        {
                                            this.props.broadcasterProfile.isFetching
                                                ?
                                                <button className="btn btn-outline-primary">
                                                    <img src={loading_white}
                                                        alt={"Loading"}
                                                        width={26}
                                                        height={26} /></button>
                                                :
                                                <button className="btn btn-outline-primary"
                                                    onClick={this.createProfile}>Create profile
                                            </button>
                                        }

                                    </div>
                                </div>
                            </form>
                        </div>
                    </main>
                </ModelTemp>
                <YotiConfirmModal
                    isCreateProfile={true}
                    yotiModalStatus={this.state.yotiModalStatus}
                    callYotiIntegration={this.callYotiIntegration}
                    navCreateBroadcast={this.navCreateBroadcast}/>
            </div>
        );
    }
}


function mapStateToProps(state) {

    if (state.account_management.userDetails !== null &&
        state.account_management.userDetails.hasOwnProperty("broadcaster") &&
        state.account_management.userDetails.broadcaster !== null &&
        state.account_management.userDetails.broadcaster.length > 0) {

        return {
            account_management: state.account_management,
            predefinedTags: state.predefinedTags,
            broadcasterProfile: state.broadcasterProfile,
            device: state.device.payload,
            profanity: state.profanity.words,
            initialValues: {
                channel_description: state.account_management.userDetails.broadcaster[0].channel_description
            }
        };
    } else {
        return {
            account_management: state.account_management,
            predefinedTags: state.predefinedTags,
            broadcasterProfile: state.broadcasterProfile,
            device: state.device.payload,
            profanity: state.profanity.words
        };
    }
}

//export default connect(mapStateToProps, actions)(CreateBroadcasterProfile);

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
CreateBroadcasterProfile = reduxForm({
    form: 'CreateProfileForm', // a unique identifier for this form
    enableReinitialize: true
})(CreateBroadcasterProfile);

// You have to connect() to any reducers that you wish to connect to yourself
CreateBroadcasterProfile = connect(
    mapStateToProps,
    actions, // bind account loading action creator
)(CreateBroadcasterProfile);

export default CreateBroadcasterProfile;